import axios from 'axios';

class CurrencyExchangeService {

    constructor(currencyExchangeServiceApiUrl) {
        this.currencyExchangeServiceApiUrl = currencyExchangeServiceApiUrl;
    }

    async getSupportedCurrencies() {

        const getUrl = `${this.currencyExchangeServiceApiUrl}/public/currency/`;
        const { data: content } = await axios.get(getUrl);
        return content.data;
    }

    async getExchangeRate(baseCurrency, targetCurrency) {

        const getUrl = `${this.currencyExchangeServiceApiUrl}/public/currency/exchange/${baseCurrency}-${targetCurrency}`;
        const { data: content } = await axios.get(getUrl);
        return content.data;
    }
    
    async getOverallInsight() {

        const getUrl = `${this.currencyExchangeServiceApiUrl}/public/currency/insight-overall`;
        const { data: content } = await axios.get(getUrl);
        return content.data;
    }

    async getCurrencyPairInsight(baseCurrency, targetCurrency) {

        const getUrl = `${this.currencyExchangeServiceApiUrl}/public/currency/insight/${baseCurrency}-${targetCurrency}`;
        const { data: content } = await axios.get(getUrl);
        return content.data;
    }
};

export default CurrencyExchangeService;